import {put} from 'redux-saga/effects';
import * as contractPartnersActionTypes from '../../contract-partners/contractPartnerActionTypes';

const loadContractPartnerMapWatcher = function* loadContractPartnerMapWatcher() {
    yield put({type: contractPartnersActionTypes.START_MAP_CONTRACT_PARTNER_WATCHER});
};

export default loadContractPartnerMapWatcher;
